import React, { Component } from 'react';

import { Row, Col } from 'reactstrap';
import { Form, FormGroup, Label, Input,FormFeedback } from 'reactstrap';
import classnames from 'classnames';
import { ButtonWithLoader } from '../../../core';
import { bseStatesList } from '../../helpers/bse_states_list';
import { store } from '../../../store';
import { setOnboardingKycContactDetails } from "../../../actions";
import { occupationList } from '../../helpers/occupation_list';

class KycRemaining extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: {}
        };

        this.updateKycContact = this.updateKycContact.bind(this);
    }

    componentDidMount() {
        let storeData = store.getState().onboarding && store.getState().onboarding.kycDetails
        this.setState({
            email: storeData ? storeData.kycData.email : undefined,
            phoneNumber: storeData ? storeData.kycData.mobile : undefined,
            name: storeData ? storeData.kycData.name : undefined,
            gender: storeData ? storeData.kycData.gender : undefined,
            occupation: storeData ? storeData.kycData.occupation : undefined,
            address1: storeData ? storeData.kycData.address1 : undefined,
            pincode: storeData ? storeData.kycData.pincode : undefined,
            city: storeData ? storeData.kycData.city : undefined,
            state: storeData ? storeData.kycData.state : undefined,

            nameInitial: storeData ? storeData.kycData.name : undefined,
            occupationInitial: storeData ? storeData.kycData.occupation : undefined,
            addressInitial: storeData ? storeData.kycData.address1 : undefined,
            pincodeInitial: storeData ? storeData.kycData.pincode : undefined,
            cityInitial: storeData ? storeData.kycData.city : undefined,
            stateInitial: storeData ? storeData.kycData.state : undefined
        })
    }


    getSnapshotBeforeUpdate() {
        let storeData = store.getState().onboarding && store.getState().onboarding.kycDetails
        return{
            email: storeData ? storeData.kycData.email : '',
            phoneNumber: storeData ? storeData.kycData.mobile : '',
            name: storeData ? storeData.kycData.name : '',
            occupation: storeData ? storeData.kycData.occupation : '',
            address1: storeData ? storeData.kycData.address1 : '',
            pincode: storeData ? storeData.kycData.pincode : '',
            city: storeData ? storeData.kycData.city : '',
            state: storeData ? storeData.kycData.state : ''
        }
    }

    updateKycContact(e) {
        e.preventDefault();
        store.dispatch(setOnboardingKycContactDetails(this.state));

        this.setState({
            submitting: true
        });

        let name = this.state.name && this.state.name.trim();
        let occupation = this.state.occupation && this.state.occupation.trim();
        let phoneNumber = this.state.phoneNumber && this.state.phoneNumber.trim();
        let address1 = this.state.address1 && this.state.address1.trim();
        let pincode = this.state.pincode && this.state.pincode.trim();
        let city = this.state.city && this.state.city.trim();
        let _state = this.state.state && this.state.state.trim();
        let gender = this.state.gender && this.state.gender.trim();


        if (!name ||
            !occupation ||
            !phoneNumber ||
            !address1 ||
            !pincode ||
            !city ||
            !_state ||
            !gender) {

            var errors = {};

            if (!name) {
                errors["name"] = "please enter you good name!";
            }

            if (!occupation) {
                errors["occupation"] = "please select your occupation!";
            }

            if (!phoneNumber) {
                errors["phoneNumber"] = "please enter your mobile no";
            }

            if (!address1) {
                errors["address1"] = "please enter your address no";
            }

            if (!pincode) {
                errors["pincode"] = "please enter your pincode";
            }

            if (!city) {
                errors["city"] = "please enter your city";
            }

            if (!_state) {
                errors["state"] = "please select your state";
            }
            if (!gender) {
                errors["gender"] = "please select your gender";
            }

            this.setState({
                errors: errors,
                submitting: false
            });
        }
        else {
            let pincodeData = this.state.pincode && this.state.pincode.trim();
            let mobileNumber =  this.state.phoneNumber && this.state.phoneNumber.trim();
            if (pincodeData.length !== 6) {
                let errors = {}
                errors["pincode"] = "pincode length should be 6";
                this.setState({
                    errors: errors,
                    submitting: false
                });
                return;
            }

            if (mobileNumber.length !== 10) {
                let errors = {}
                errors["phoneNumber"] = "mobile number length should be 10";
                this.setState({
                    errors: errors,
                    submitting: false
                });
                return;
            }

            if (this.props.checkFor === 'BSE_SETUP') {
                this.props.goToBank("KYC_COMPLETE");
                return;
            }
            this.props.onComplete(this.props.stepName, {});
        }
    }

    render() {
        //console.log(store.getState().onboarding, 'store.getState().onboarding', this.state)
        return (
            <div className="kyc-completed">
                <Row className="justify-content-center">
                    <Col xs={12} md={6} lg={5}>
                        <p>
                            Great, you're already KYC ready. 
                            Check your information that is registered in your KYC. 
                            You can fill/update them to keep your KYC up to date. 
                        </p>
                    </Col>
                    <Col xs={12} md={6} lg={5}>
                        <Form className="login-form" onSubmit={this.updateKycContact}>
                            {/* {
                                <FormGroup>
                                    <Label for="pan"
                                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.email })} >
                                        Email
                                    </Label>

                                    <Input type="email"
                                        name="pan"
                                        id="pan"
                                        className="form-control font-weight-semi-bold text-lowercase"
                                        placeholder="Email"
                                        onChange={e => this.setState({ email: e.target.value })}
                                        value={this.state.email}
                                    />
                                </FormGroup>

                            } */}

                            { !this.state.nameInitial &&
                                <FormGroup>
                                    <Label for="name"
                                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.name })} >
                                        Full name
                                    </Label>

                                    <Input type="text"
                                        name="name"
                                        id="name"
                                        className="form-control font-weight-semi-bold"
                                        placeholder="Full name"
                                        onChange={e => this.setState({ name: e.target.value })}
                                        value={this.state.name}
                                        invalid={this.state.errors.name}
                                    />
                                    <FormFeedback className={classnames({ invisible: (!this.state.errors.name || this.state.errors.name.length === 0) })}>
                                        {this.state.errors.name}
                                    </FormFeedback>
                                </FormGroup>

                            }

                            { !this.state.addressInitial &&
                                <FormGroup>
                                    <Label for="address1"
                                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.address1 })} >
                                        Mailing Address Line 1
                                    </Label>

                                    <Input type="text"
                                        name="address1"
                                        id="address1"
                                        className="form-control font-weight-semi-bold"
                                        placeholder="Mailing Address Line 1"
                                        onChange={e => this.setState({ address1: e.target.value })}
                                        value={this.state.address1}
                                        invalid={this.state.errors.address1}
                                    />
                                    <FormFeedback className={classnames({ invisible: (!this.state.errors.address1 || this.state.errors.address1.length === 0) })}>
                                        {this.state.errors.address1}
                                    </FormFeedback>
                                </FormGroup>

                            }

                            { !store.getState().onboarding.kycDetails.gender &&
                                <FormGroup>
                                    <Label for="gender" 
                                            className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.gender })} >
                                            Gender
                                    </Label>
                      
                                    <select className="custom-select border-bottom border-1 form-control" 
                                            id="gender" 
                                            name="gender" 
                                            value={this.state.gender}
                                            onChange={e => this.setState({gender: e.target.value})}
                                    >
                                        <option value="" key="none">Gender</option>
                                        <option value="M" key="Male">Male</option> 
                                        <option value="F" key="Female">Female</option>
                                    </select>
                                    <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.gender || this.state.errors.state.length === 0) })}>
                                        {this.state.errors.gender}
                                    </FormFeedback>
                                </FormGroup>
                            }

                            { !this.state.cityInitial &&
                                <FormGroup>
                                    <Label for="city"
                                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.city })} >
                                        City
                                    </Label>

                                    <Input type="text"
                                        name="city"
                                        id="city"
                                        className="form-control font-weight-semi-bold"
                                        placeholder="City"
                                        onChange={e => this.setState({ city: e.target.value })}
                                        value={this.state.city}
                                        invalid={this.state.errors.city}
                                    />
                                    <FormFeedback className={classnames({ invisible: (!this.state.errors.city || this.state.errors.city.length === 0) })}>
                                        {this.state.errors.city}
                                    </FormFeedback>
                                </FormGroup>

                            }

                            { !(this.state.pincodeInitial && this.state.pincodeInitial.trim() && (this.state.pincodeInitial.trim()).length === 6) &&
                                <FormGroup>
                                    <Label for="pincode"
                                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.pincode })} >
                                        Pincode
                                    </Label>

                                    <Input type="number"
                                        name="pincode"
                                        id="pincode"
                                        className="form-control font-weight-semi-bold"
                                        placeholder="Pincode"
                                        onChange={e => this.setState({ pincode: e.target.value })}
                                        value={this.state.pincode && this.state.pincode.trim()}
                                        invalid={this.state.errors.pincode}
                                    />
                                    <FormFeedback className={classnames({ invisible: (!this.state.errors.pincode || this.state.errors.pincode.length === 0) })}>
                                        {this.state.errors.pincode}
                                    </FormFeedback>
                                </FormGroup>

                            }

                            { !this.state.stateInitial &&
                                <FormGroup>
                                    <Label for="state"
                                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.state })} >
                                        State
                                    </Label>

                                    <select className="custom-select border-bottom border-1 form-control"
                                        id="state"
                                        name="state"
                                        value={this.state.state}
                                        onChange={e => this.setState({ state: e.target.value })}
                                    >
                                        <option value="" key="none">State</option>
                                        {
                                            bseStatesList.map(state => (
                                                <option value={state.name} key={state.name}>{state.name}</option>
                                            ))
                                        }
                                    </select>
                                    <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.state || this.state.errors.state.length === 0) })}>
                                        {this.state.errors.state}
                                    </FormFeedback>
                                </FormGroup>

                            }

                            {
                                <FormGroup>
                                    <Label for="phoneNumber"
                                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.phoneNumber })} >
                                        Phone Number
                                    </Label>

                                    <Input type="text"
                                        name="phoneNumber"
                                        id="phoneNumber"
                                        className="form-control font-weight-semi-bold"
                                        placeholder="Phone Number"
                                        onChange={e => this.setState({ phoneNumber: e.target.value })}
                                        value={this.state.phoneNumber}
                                        invalid={this.state.errors.phoneNumber}
                                    />
                                    <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.phoneNumber || this.state.errors.phoneNumber.length === 0) })}>
                                        {this.state.errors.phoneNumber}
                                    </FormFeedback>
                                </FormGroup>

                            }

                            { !this.state.occupationInitial &&
                                <FormGroup>
                                    <Label for="occupation"
                                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.occupation })} >
                                        Occupation
                                </Label>

                                    <select className="custom-select border-bottom border-1 form-control"
                                        id="occupation"
                                        name="occupation"
                                        value={this.state.occupation}
                                        onChange={e => this.setState({ occupation: e.target.value })}
                                    >
                                        <option value="" key="none">Occupation</option>
                                        {occupationList.map(occupation => (
                                            <option value={occupation.name.toUpperCase()} key={occupation.name}>{occupation.name}</option>
                                        ))}
                                    </select>
                                    <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.occupation || this.state.errors.occupation.length === 0) })}>
                                        {this.state.errors.occupation}
                                    </FormFeedback>
                                </FormGroup>
                            }

                            <FormGroup className="cta-block">
                                <ButtonWithLoader
                                    text="Save & continue"
                                    isLoading={this.state.isSubmitting}
                                    color="primary"
                                    className="w-100"
                                />
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default KycRemaining;